module.exports = __webpack_public_path__ + "img/06.1c16dd42.png";